import React, { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';

import RMSCommonDialog from '../../../shared/components/dialog/RMSCommonDialog';
import { RMSTextField } from '../../../shared/components/form-controls';
import CreateFormResolver from '../../../shared/utility/createFormResolver';
import resolveNoteSchema from '../../schema/resolveNoteSchema';
import { notify } from 'reducers/NotifierReducer';
import { getFirstErrorMessage } from '../../../shared/utility/helper';
import { RESOLVE_NOTE_DEFAULT_VALUES } from '../../constants/resolveNoteConstants';

const MarkResolvedDialog = ({ open, onClose, onSave }) => {
  const dispatch = useDispatch();

  const methods = useForm({
    resolver: CreateFormResolver(resolveNoteSchema),
    mode: 'all',
    defaultValues: RESOLVE_NOTE_DEFAULT_VALUES,
  });

  const {
    reset,
    handleSubmit,
    formState: { isDirty },
  } = methods;

  useEffect(() => {
    if (open) {
      reset(RESOLVE_NOTE_DEFAULT_VALUES);
    }
  }, [open, reset]);

  const handleClose = () => {
    reset(RESOLVE_NOTE_DEFAULT_VALUES);
    onClose();
  };

  const handleResolve = (data) => {
    onSave(data);
    handleClose();
  };

  const handleDialogSave = handleSubmit(handleResolve, (errors) => {
    dispatch(notify(getFirstErrorMessage(errors), 'error'));
  });

  return (
    <RMSCommonDialog
      open={open}
      title="Mark Resolved"
      saveButton={{
        show: true,
        type: 'simple',
        color: 'primary',
        label: 'Mark Resolved',
      }}
      cancelButton={{
        show: true,
        type: 'simple',
        label: 'Cancel',
      }}
      onClose={handleClose}
      onSave={handleDialogSave}
      saveDisabled={!isDirty}
      closeOnBackdropClick={false}
      maxWidth="sm"
      fullWidth>
      <FormProvider {...methods}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <RMSTextField
              name="resolutionNotes"
              label="Resolution Notes"
              placeholder="Describe what was corrected and how the issue was resolved..."
              multiline
              rows={5}
              autoFocus
            />
          </Grid>
        </Grid>
      </FormProvider>
    </RMSCommonDialog>
  );
};

export default MarkResolvedDialog;
